var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('header',{staticClass:"jds-px-8"},[_vm._t("header")],2),_c('div',{staticClass:"jds-px-4"},[_vm._t("default")],2),_c('footer',{staticClass:"jds-p-4 jds-text-center"},[_vm._t("footer")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }